export const authMapping = (responseData) => {
    const {access_token, refresh_token, profile} = responseData || {};

    return {
        accessToken: access_token,
        refreshToken: refresh_token,
        consumerId: profile?.consumerId,
    };
};

export const authUamMapping = (responseData) => {
    return {
        authToken: responseData.AuthToken,
        identityKey: responseData.IdentityKey,
        uamUrl: responseData.UamUrl,
        uamApiKey: responseData.UamApiKey,
    };
};

export const loginTokenMapping = (responseData) => {
    return {
        campaignUrlPersonal: responseData.CampaignUrlPersonal,
    };
};
